































































import { Component, Vue } from 'vue-property-decorator'
import { timerTypes } from '@/constant/timerConstant'
import { IAddTimer, IRetTimer, IUpdateTimer } from '@/types/timer/types'
import { apiAddTimer, apiSearchTimerLastOne, apiUpdateTimer } from '@/api/timer'
import moment from 'moment'
import { USER } from "@/constant/storageConstant";
import { getUser } from "@/api/user";

@Component({
  name: 'Timer'
})
export default class extends Vue {
  private countdownTimer: any | undefined

  private isLogin = false
  private timerStatus = false
  private timerTypes = timerTypes
  private timerUseTime = 0
  private timerFormatUseTime = ''
  private timerIsEdit = false
  private isShowTypeSelect = false
  private timerSelectType = 1
  private timerLastOne: IRetTimer | undefined
  private confirmLoading = false
  private addTimer: IAddTimer = {
    type: 1
  }
  private updateTimerCreateTime: string = ''
  private updateTimer: IUpdateTimer = {
    id: 0
  }

  mounted () {
    const isLogin = localStorage.getItem(USER) !== null
    if (!isLogin) {
      this.getUserAndInitData()
    } else {
      this.initData()
    }
  }

  beforeDestroy () {
    // 清除定时刷新，不清除会一直运行，关闭页面也会定时刷新
    if (this.countdownTimer !== undefined) {
      clearInterval(this.countdownTimer);
    }
  }

  private initData () {
    this.initTimer()
    const updateTimerUseTime = this.updateTimerUseTime
    this.countdownTimer = setInterval(function () {
      updateTimerUseTime()
    }, 1000)
  }

  private async getUserAndInitData () {
    const result = await getUser()
    if (result.status) {
      localStorage.setItem(USER, JSON.stringify(result.data))
      this.initData()
    }
  }

  private async initTimer () {
    const result = await apiSearchTimerLastOne()
    if (result.status) {
      this.isLogin = true
      this.timerLastOne = result.data
      this.calTimerLastOne()
      if (this.timerLastOne?.status == 1) {
        this.timerStatus = true
        this.timerUseTime = moment().unix() - parseInt((this.timerLastOne.createTime / 1000).toString())
      }
    }
  }

  private updateTimerUseTime () {
    if (this.timerStatus) {
      this.timerUseTime++
      this.calTimerFormatUseTime()
    }
  }

  private calShowTypeSelect () {
    if (this.timerLastOne === undefined) {
      this.isShowTypeSelect = true
    } else {
      if (this.timerIsEdit) {
        this.isShowTypeSelect = true
      } else {
        this.isShowTypeSelect = this.timerLastOne.status == 2;
      }
    }
  }

  private calTimerType (type: number) {
    for (let t of this.timerTypes) {
      if (t.value === type) {
        this.timerSelectType = t.value
        return t.label
      }
    }
    return ''
  }

  private calTimerLastOne () {
    this.calShowTypeSelect()
    if (this.timerLastOne !== undefined) {
      if (this.timerLastOne.status == 1) {
        this.addTimer.relatedId = this.timerLastOne.id
        this.addTimer.type = this.timerLastOne.type
      } else {
        this.addTimer.relatedId = undefined
      }

      this.updateTimer.id = this.timerLastOne.id
      this.updateTimer.createTime = this.timerLastOne.updateTime
      this.updateTimer.type = this.timerLastOne.type
      this.updateTimerCreateTime = moment(this.timerLastOne.createTime).format('YYYY-MM-DD HH:mm:ss')
    } else {
      this.updateTimer.type = 1
    }
  }

  private async confirmTimer () {
    this.confirmLoading = true
    if (this.timerIsEdit) {
      this.updateTimer.type = this.timerSelectType
      this.updateTimer.createTime = moment(this.updateTimerCreateTime, 'YYYY-MM-DD HH:mm:ss').unix() * 1000
      let oldStatus: number = 1
      if (this.timerLastOne !== undefined) {
        oldStatus = this.timerLastOne.status
      }
      const result = await apiUpdateTimer(this.updateTimer)
      if (result.status) {
        this.$message.success('更新计时器成功')
        this.timerLastOne = result.data
        if (this.timerLastOne !== undefined) {
          this.timerLastOne.status = oldStatus
        }
        this.calTimerLastOne()
        if (this.timerLastOne?.status == 1) {
          this.timerStatus = true
          this.timerUseTime = moment().unix() - parseInt((this.timerLastOne.createTime / 1000).toString())
        }
      }
    } else {
      this.addTimer.type = this.timerSelectType
      const result = await apiAddTimer(this.addTimer)
      if (result.status) {
        this.$message.success('添加计时器成功')
        this.timerLastOne = result.data
        this.calTimerLastOne()
        if (this.timerLastOne?.status == 1) {
          this.timerStatus = true
          this.timerUseTime = moment().unix() - parseInt((this.timerLastOne.createTime / 1000).toString())
        } else {
          this.timerStatus = false
        }
      }
    }
    this.confirmLoading = false
  }

  private calTimerFormatUseTime () {
    const h = parseInt((this.timerUseTime / 3600).toString())
    const m = parseInt(((this.timerUseTime % 3600) / 60).toString())
    const s = (this.timerUseTime % 3600) % 60
    this.timerFormatUseTime = h + '时' + m + '分' + s + '秒'
  }
}
